export const GENERAL_CHANNEL = 'general'